/** total (€) – the coins alone were stored under `screenable.game.best` before the special coins */
const STORAGE_KEY = 'screenable.game.best-eur';

/** Personal best (depot + subsidy, €) on this device. Storage may be unavailable (private mode) – then it lives in memory only. */
export class BestScore {
  private value = 0;

  constructor() {
    try {
      this.value = Number(localStorage.getItem(STORAGE_KEY)) || 0;
    } catch {
      this.value = 0;
    }
  }

  get best(): number {
    return this.value;
  }

  /** Returns true if `score` is a new best. */
  submit(score: number): boolean {
    if (score <= this.value) return false;
    this.value = score;
    try {
      localStorage.setItem(STORAGE_KEY, String(score));
    } catch {
      // ignore
    }
    return true;
  }
}
